export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      fill="currentColor"
      fill-opacity=".87"
      d="M5.116 8.902a.707.707 0 0 1 .226-1.15.698.698 0 0 1 .762.151l2.16 2.174V.713A.713.713 0 0 1 9.484.21c.134.134.209.315.209.504v9.364l2.143-2.174a.696.696 0 0 1 .988 0 .707.707 0 0 1 0 .999L9.46 12.325a.69.69 0 0 1-.995 0L5.116 8.902Zm11.16 1.232a.703.703 0 0 0-.703.696v3.355a.416.416 0 0 1-.417.417H2.8a.418.418 0 0 1-.417-.417V10.83a.701.701 0 0 0-1.2-.496.701.701 0 0 0-.205.496v3.355A1.82 1.82 0 0 0 2.8 16h12.355a1.824 1.824 0 0 0 1.822-1.815V10.83a.701.701 0 0 0-.702-.696Z"
    />
  </svg>
);
